/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   Senad Halilovic - Extensive modernization and added functionality
 *
 *******************************************************************************/

import React, { useState } from 'react'
 import {
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
} from '@mui/material'  

import PageSubHeader from "../../../components/Layout/PageSubHeader"

 

const LoginPage = ()=>{
   const [username] = useState('')
   const [password] = useState('')

    return (
      <>
        <PageSubHeader location={'Login'} />


        <Grid item xs={12} sm={6} md={4}
          style={{ margin: 'auto', marginTop: '10px' }}
        >
          <Card  >
            <CardContent>
              <Typography align="center" gutterBottom color="primary" variant="h5">
                LOGIN
              </Typography>
              <TextField
                required
                id="name"
                name="username"
                label="Username"
                type="username"
                 margin="normal"
                variant="outlined"
                color="primary"
        
                value={username}
                fullWidth
               />
              <TextField
                required
                id="password"
                name="password"
                label="Password"
                type="password"
                 margin="normal"
                variant="outlined"
                value={password}
                color="primary"
                fullWidth
                
              />
              <Typography>
                {alert.type === 'error' && 'Email or password is invalid'}
              </Typography>


              <Button
                fullWidth
                variant="contained"
                color="primary" 
              >
                Login
              </Button>

            </CardContent>
          </Card>
         </Grid>
      </>
    ) 
}

export default LoginPage;